import gql from 'graphql-tag';

export default gql`
    mutation RevertBoxes($input: RevertBoxesInput) {
        revertBoxes(input: $input) {
            errors
        }
    }
`;